import BasicDomain from "./BasicDomain";
import * as yup from 'yup';

export default class Event extends BasicDomain {
    static DEFAULTS = {
        name: '',
        description: '',
        note: '',
        type: null,
        startDate: null,
        endDate: null,
        dateSpecificity: 'yyyy-mm-dd',
        locations: []
    }

    static FIELDS = [
        { field: 'name', label: 'Name', type: 'String' },
        { field: 'description', label: 'Description', type: 'String' },
        { field: 'note', label: 'Note', type: 'String' },
        { field: 'type', label: 'Event Type', type: { type: 'Pointer', targetClass: 'EventType' } },
        { field: 'startDate', label: 'Start Date', type: 'Date' },
        { field: 'endDate', label: 'End Date', type: 'Date' },
        { field: 'dateSpecificity', label: 'Date Specificity', type: 'String' }
    ];
  
    static VALIDATION_SCHEMA = yup.object().shape({
        name: yup.string().required('Name is required'),
        type: yup.object().required('Event type is required'),
        startDate: yup.date().required('Start date is required'),
        endDate: yup.date()
            .required('End date is required')
            .test('end-date-after-start', 'End date must be after start date', function(value) {
                const { startDate } = this.parent;
                if (!startDate || !value) return true;
                return new Date(value) >= new Date(startDate);
            }),
        dateSpecificity: yup.string().oneOf(['yyyy-mm-dd', 'yyyy-mm', 'yyyy'], 'Invalid date specificity')
    });

    constructor(props) {
        super('Event', props, Event.DEFAULTS);
    }

    inspect = () => {
        return Event.VALIDATION_SCHEMA.validate(this, { abortEarly: false });
    }
}